import Alert from '@mui/material/Alert';
import { FieldProps } from '@rjsf/utils';

// The pure UI component (for use within other React components)
export const InfoAlert = ({ text, sx }: { text?: string; sx?: any }) => {
  if (!text) return null;

  return (
    <Alert severity="info" sx={sx}>
      {text}
    </Alert>
  );
};

// The Backstage Custom Field Extension (for use directly in the template.yaml)
export const InfoAlertField = ({ uiSchema }: FieldProps<string>) => {
  // Read the text from the ui:options in the yaml
  const text = (uiSchema as any)?.['ui:options']?.text as string | undefined;

  // Standard bottom margin for the standalone field
  return <InfoAlert text={text} sx={{ mb: 2 }} />;
};
